
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cities/[id]",
      function () {
        return require("private-next-pages/cities/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cities/[id]"])
      });
    }
  